export const deleteCart = () => {
  localStorage.removeItem('cart')
}
